/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TaglineInputs */

const en_tagline = /** @type {(inputs: TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship with your AI agent. One step at a time.`)
};

const id_tagline = /** @type {(inputs: TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngoding bareng AI agent. Selangkah demi selangkah.`)
};

/**
* | output |
* | --- |
* | "Ship with your AI agent. One step at a time." |
*
* @param {TaglineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tagline = /** @type {((inputs?: TaglineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TaglineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tagline(inputs)
	return en_tagline(inputs)
});